// https://github.com/typeslick/status-code-enum
enum HttpStatusType {
  Info = 1,
  Success,
  Redirect,
  ClientError,
  ServerError
}

/**
 * httpéç¨ç±»
 */
class HttpUtil {

  /**
   * åºäºhttpç¶æç è¿åç¶æç±»å
   * @param httpResponseSatus httpè¯·æ±è¿åç¶æç 
   * @returns null | HttpStatusType
   */
  public static getHttpStatusType(httpResponseSatus: number): any {
    if (httpResponseSatus === null || httpResponseSatus === undefined) {
      return null;
    }

    let statusType = null; // é»è®¤å¼ä¸ºç©º

    if (httpResponseSatus === 0) {
      statusType = HttpStatusType.ClientError;
    } else if (httpResponseSatus < 100 || httpResponseSatus > 600) {
      statusType = null; // ä¸åçç¶æç 
    } else if (httpResponseSatus >= 100 && httpResponseSatus < 200) {
      statusType = HttpStatusType.Info;
    } else if (httpResponseSatus >= 200 && httpResponseSatus < 300) {
      statusType = HttpStatusType.Success;
    } else if (httpResponseSatus >= 300 && httpResponseSatus < 400) {
      statusType = HttpStatusType.Redirect;
    } else if (httpResponseSatus >= 400 && httpResponseSatus < 500) {
      if (httpResponseSatus === 403) {
        statusType = HttpStatusType.ServerError;
      } else {
        statusType = HttpStatusType.ClientError;
      }
    } else if (httpResponseSatus >= 500 && httpResponseSatus < 600) {
      statusType = HttpStatusType.ServerError;
    }

    return statusType;
  }
}

export { HttpUtil, HttpStatusType };
